<!--  -->
<template>
  <div class="linkage-container section-main__warp">
    <ioc-table
      :data="tableData"
      :option="tableOption"
      :page="page"
      @size-change="sizeChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @current-change="pageChange"
    >
      <template slot="menuLeft">
        <el-button type="primary" icon="el-icon-plus" @click="addLinkage"
          >新增</el-button
        >
      </template>

      <!-- 表格按钮 自定义 -->
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="详情"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-Detail"
            @click="showDetail(scope.row)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="修改"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-xiugai"
            @click="handleEdit(scope.row)"
          ></el-button>
        </el-tooltip>

        <el-tooltip
          class="item"
          effect="dark"
          content="删除"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-shanchu"
            @click="handleDel(scope.row, scope.index)"
          ></el-button>
        </el-tooltip>
      </template>
    </ioc-table>
    <app-panel
      :title="addPanelTitle"
      :isExpand="showAddPanel"
      @cancel="handleClosePanel"
    >
      <el-form
        style="height: 100%; position: absolute; width: 100%"
        ref="linkageForm"
        :model="linkageForm"
        :inline="true"
        :label-width="addPanelTitle === '详情' ? '150px' : '110px'"
        label-position="right"
        label-suffix=" ："
        :rules="linkageRules"
      >
        <el-scrollbar style="height: 100%; padding-bottom: 10px">
          <!-- <div class="flex-row"> -->
          <el-col :span="12">
            <el-form-item prop="linkageName" label="联动名称">
              <span v-if="addPanelTitle === '详情'">
                {{ linkageForm.linkageName }}
              </span>
              <el-input
                v-else
                class="form-value"
                placeholder="请输入联动规则名称"
                v-model="linkageForm.linkageName"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="alarmType" label="事件类型">
              <span v-if="addPanelTitle === '详情'">
                {{ linkageForm.alarmType | dic("SENU085") }}
              </span>
              <!-- @change="alarmChange" -->
              <el-select
                v-else
                class="form-value"
                placeholder="请选择事件类型"
                clearable
                v-model="linkageForm.alarmType"
              >
                <el-option
                  v-for="item in linkageAlarms"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- </div> -->
          <!-- <div class="flex-row"> -->
          <el-col :span="12">
            <el-form-item prop="durations" label="播放时长">
              <span v-if="addPanelTitle === '详情'">
                {{ linkageForm.durations + "s" }}
              </span>
              <el-input
                v-else
                class="form-value"
                placeholder="请输入播放时长"
                v-model="linkageForm.durations"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="randomPlay" label="播放方式">
              <span v-if="addPanelTitle === '详情'">
                {{ playOrders[Number(linkageForm.randomPlay)].label }}
              </span>
              <el-select
                v-else
                :disabled="addPanelTitle === '详情'"
                v-model="linkageForm.randomPlay"
                clearable
                placeholder="请选择音频播放顺序"
              >
                <el-option
                  v-for="item in playOrders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!-- </div> -->
            <!-- <div class="flex-row"> -->
            <el-form-item prop="cameraList" label="监控点位">
              <span
                type="text"
                style="font-size: 14px; cursor: pointer"
                class="el-icon-circle-plus-outline"
                v-if="addPanelTitle !== '详情'"
                @click="addDevice(1)"
              >
                添加</span
              >
              <div v-if="addPanelTitle !== '详情'">
                <ioc-table
                  class="height300"
                  :data="linkageForm.cameraList"
                  :option="monitorPointOption"
                >
                  <template
                    slot="menu"
                    slot-scope="scope"
                    v-if="addPanelTitle !== '详情'"
                  >
                    <el-tooltip
                      effect="dark"
                      content="删除"
                      placement="top"
                      popper-class="tooltip-draw"
                    >
                      <el-button
                        class="font20"
                        type="text"
                        icon="el-icon-remove-outline"
                        @click.stop="deleteFormItem('cameraList', scope.index)"
                      ></el-button>
                    </el-tooltip>
                  </template>
                </ioc-table>
              </div>
              <div v-else class="form-value has-bg">
                <div
                  class="form-item"
                  v-for="(item, index) in linkageForm.cameraList"
                  :key="'camera-' + index"
                >
                  <div class="text-ellipse">
                    <span :title="item.name">{{ item.name }}</span>
                  </div>
                  <el-tooltip
                    v-if="addPanelTitle !== '详情'"
                    effect="dark"
                    content="删除摄像设备"
                    placement="top"
                    popper-class="tooltip-draw"
                  >
                    <el-button
                      type="text"
                      class="font20"
                      icon="el-icon-remove-outline"
                      @click.stop="deleteFormItem('cameraList', index)"
                    ></el-button>
                  </el-tooltip>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="broadcastList" label="联动广播">
              <span
                type="text"
                style="font-size: 14px; cursor: pointer"
                class="el-icon-circle-plus-outline"
                v-if="addPanelTitle !== '详情'"
                @click="addDevice(2)"
              >
                添加</span
              >
              <div v-if="addPanelTitle !== '详情'">
                <ioc-table
                  class="height300"
                  :data="linkageForm.broadcastList"
                  :option="broadcastOption"
                >
                  <template slot="menu" slot-scope="scope">
                    <el-tooltip
                      effect="dark"
                      content="删除"
                      placement="top"
                      popper-class="tooltip-draw"
                    >
                      <el-button
                        type="text"
                        class="font20"
                        icon="el-icon-remove-outline"
                        @click.stop="
                          deleteFormItem('broadcastList', scope.index)
                        "
                      ></el-button>
                    </el-tooltip>
                  </template>
                </ioc-table>
              </div>
              <div v-else class="form-value has-bg">
                <div
                  class="form-item"
                  v-for="(item, index) in linkageForm.broadcastList"
                  :key="'camera-' + index"
                >
                  <div class="text-ellipse">
                    <i
                      class="form-item-icon iconfont-lunan icon-lunan-radio"
                    ></i>
                    <span :title="item.name">{{ item.name }}</span>
                  </div>
                  <el-tooltip
                    v-if="addPanelTitle !== '详情'"
                    effect="dark"
                    content="删除广播设备"
                    placement="top"
                    popper-class="tooltip-draw"
                  >
                    <el-button
                      type="text"
                      class="font20"
                      icon="el-icon-remove-outline"
                      @click.stop="deleteFormItem('broadcastList', index)"
                    ></el-button>
                  </el-tooltip>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!-- </div> -->
            <!-- <div class="flex-row"> -->
            <el-form-item prop="audioList" label="联动音频">
              <span
                type="text"
                style="font-size: 14px; cursor: pointer"
                class="el-icon-circle-plus-outline"
                v-if="addPanelTitle !== '详情'"
                @click="addDevice(3)"
              >
                添加</span
              >
              <template>
                <div v-if="addPanelTitle !== '详情'">
                  <ioc-table
                    class="height300"
                    :data="linkageForm.audioList"
                    :option="audioOption"
                  >
                    <!-- <template slot="fileCode" slot-scope="scope">
                      <audio
                        class="audio-comp"
                        style="width: 220px"
                        controls
                        :src="$utils.Bus.imgPath(scope.row.fileCode)"
                      >
                        您的浏览器不支持 audio 标签。
                      </audio>
                    </template> -->
                    <template slot="menu" slot-scope="scope">
                      <el-tooltip
                        effect="dark"
                        content="删除"
                        placement="top"
                        popper-class="tooltip-draw"
                      >
                        <el-button
                          type="text"
                          class="font20"
                          icon="el-icon-remove-outline"
                          @click.stop="deleteFormItem('audioList', scope.index)"
                        ></el-button>
                      </el-tooltip>
                    </template>
                  </ioc-table>
                </div>
                <div v-else>
                  <div
                    class="form-item"
                    v-for="(item, index) in linkageForm.audioList"
                    :key="'camera-' + index"
                  >
                    <div class="flex-row">
                      <div class="flex-between" style="margin: 10px">
                        <div class="text-ellipse" style="width: 150px">
                          <i
                            class="
                              form-item-icon
                              iconfont-lunan
                              icon-lunan-yinpin
                            "
                            style="margin: 0 10px"
                          ></i>
                          <span :title="item.name">{{ item.name }}</span>
                        </div>
                      </div>
                      <audio
                        class="audio-comp"
                        style="width: 300px"
                        controls
                        :src="$utils.Bus.imgPath(item.fileCode)"
                      >
                        您的浏览器不支持 audio 标签。
                      </audio>
                    </div>
                  </div>
                </div>
              </template>
            </el-form-item>
          </el-col>
          <!-- </div> -->
        </el-scrollbar>
      </el-form>
      <div slot="footer" v-if="addPanelTitle !== '详情'">
        <el-button @click="deviceCancel">取消</el-button>
        <el-button type="primary" @click="deviceConfirm">保存</el-button>
      </div>
      <div slot="footer" v-else>
        <el-button @click="deviceClose">关闭</el-button>
      </div>
    </app-panel>

    <!--设备-->
    <app-panel
      :title="devicePanelTitle"
      :isExpand="showDevicePanel"
      @cancel="handleCloseDevicePanel"
    >
      <!-- <div class="device-search">
        <el-input :placeholder="devicePlaceholder"> </el-input>
      </div> -->
      <div class="device-list" v-if="devicePanelTitle == '添加视频监控点'">
        <!-- <el-scrollbar style="height: 100%">
          <el-input
            v-model="filterCamera"
            placeholder="请输入监控点名称"
            style="margin-bottom: 10px; padding-right: 1px"
          >
          </el-input>
          <el-checkbox-group
            v-model="monitorPointList"
            @change="deviceChange"
            ref="checkbox"
          >
            <div
              class="check-content"
              v-for="item in deviceListNew"
              :key="item.deviceId"
            >
              <el-checkbox :label="item.name"></el-checkbox>
              <span class="device-area">{{ item.areaName }}</span>
            </div>
          </el-checkbox-group>
        </el-scrollbar> -->
        <DeviceTree
          ref="cameraTree"
          :isPageTree="true"
          :ajaxOption="ajaxOption"
          :deviceOption="deviceOption"
          :showCheckbox="true"
          @saveChecked="handleSaveChecked"
          @data="treeDataHandler"
          style="height: 100%; overflow: hidden"
        />
      </div>
      <div class="device-list" v-else-if="devicePanelTitle == '添加广播设备'">
        <el-scrollbar class="full-height" style="height: 100%">
          <el-input
            v-model="filterBroadcast"
            placeholder="请输入名称"
            style="margin-bottom: 10px; padding-right: 1px"
          >
          </el-input>
          <el-tree
            style="padding: 10px"
            ref="deviceTree"
            :data="treeData"
            :default-expanded-keys="expandedKeys"
            node-key="id"
            :filter-node-method="filterBroadcastNode"
            :props="treeProps"
          >
            <div
              slot-scope="{ data }"
              :title="'广播：' + data.name"
              class="showOverText"
              style="width: 100%"
            >
              <i
                v-show="data.nodeType === 'device'"
                style="color: #3e76e6"
                class="iconfont-lunan icon-lunan-guangbo"
              ></i>
              <span style="margin-left: 5px">{{ data.name }}</span>
            </div>
          </el-tree>
        </el-scrollbar>
      </div>
      <div class="device-list" v-else>
        <el-table
          :data="audioData"
          ref="audioTable"
          style="height: 100%"
          @selection-change="audioChoose"
        >
          <el-table-column type="selection" align="center" />
          <el-table-column label="音频名称" prop="name"></el-table-column>
          <el-table-column label="试听">
            <template slot-scope="scope">
              <audio
                class="audio-comp-list"
                controls
                :src="$utils.Bus.imgPath(scope.row.fileCode)"
              >
                您的浏览器不支持 audio 标签。
              </audio>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button @click="handleDeviceCancel">取消</el-button>
        <el-button type="primary" @click="handleDeviceConfirm">确定</el-button>
      </div>
    </app-panel>
  </div>
</template>

<script>
import tableOption from "../option/linkage.js";
import { api } from "../api";
import utils from "@src/common/utils";
import { Dic } from "$utils";
import appPanel from "@src/components/business/app-panel/index.vue";
import DeviceTree from "@src/components/business/app-device-tree";
export default {
  data() {
    return {
      ajaxOption: {
        api: "/bms/device/queryDeviceWorkGroupDeviceTree.json",
        params: {
          deviceType: 10,
        },
      },
      deviceOption: {
        icon: "iconfont-lunan icon-lunan-shexiangtou",
        nodeType: "device",
        key: "id",
      },
      searchForm: {
        creator: "",
        alarmType: "",
        linkageName: "",
      },
      devicePanelTitle: "",
      showDevicePanel: false,
      devicePlaceholder: "",
      tableData: [],
      tableOption: tableOption(),
      page: {
        pageNum: 1,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
        total: 0,
      },
      treeProps: {
        label: "name",
        children: "subTreeModelList",
      },
      treeData: [],
      choosedList: [],
      expandedKeys: [],
      addPanelTitle: "",
      showAddPanel: false,
      linkageForm: {
        cameraList: [],
        broadcastList: [],
        audioList: [],
        durations: "",
        randomPlay: "",
        alarmType: "",
        linkageName: "",
      },
      linkageRules: {
        linkageName: [
          {
            required: true,
            message: "请输入广播联动规则名称",
            trigger: "change",
          },
        ],

        alarmType: [
          {
            required: true,
            message: "请选择告警类型",
            trigger: "change",
          },
        ],
        durations: [
          {
            required: true,
            message: "请输入播放时长",
            trigger: "change",
          },
        ],
        randomPlay: [
          {
            required: true,
            message: "请选择播放方式",
            trigger: "change",
          },
        ],
        broadcastList: [
          {
            required: true,
            message: "请添加广播设备",
            trigger: "change",
          },
        ],
        cameraList: [
          {
            required: true,
            message: "请添加监控点",
            trigger: "change",
          },
        ],
        audioList: [
          {
            required: true,
            message: "请添加音频",
            trigger: "change",
          },
        ],
      },
      linkageAlarms: Dic.find("SENU085"),
      deviceListNew: [],
      deviceIdList: [],
      audioData: [],
      typeValue: "",
      playOrders: [
        {
          value: "0",
          label: "顺序播放",
        },
        {
          value: "1",
          label: "随机播放",
        },
      ],
      monitorPointList: [], //监控点
      broadcastList: [], //广播
      monitorPointOption: {
        index: true,
        indexLabel: "序号",
        column: [
          {
            label: "监控点名称",
            prop: "name",
            hide: false,
            span: 24,
            align: "center",
          },
        ],
      },
      audioOption: {
        index: true,
        indexLabel: "序号",
        column: [
          {
            label: "文件名",
            prop: "name",
            hide: false,
            span: 24,
            align: "center",
          },
          // {
          //   label: "音频",
          //   prop: "fileCode",
          //   hide: false,
          //   span: 24,
          //   align: "center",
          //   columnWidth: 200,
          //   formslot: true,
          // },
        ],
      },
      broadcastOption: {
        index: true,
        indexLabel: "序号",
        column: [
          {
            label: "广播名称",
            prop: "name",
            hide: false,
            span: 24,
            align: "center",
          },
        ],
      },
      options: [
        { label: "人员", value: "1", children: [] },
        { label: "车辆", value: "2", children: [] },
        { label: "周界入侵", value: "3", children: [] },
        { label: "消防通道占用", value: "4", children: [] },
      ],
      filterCamera: "",
      filterBroadcast: "",
    };
  },

  components: {
    appPanel,
    DeviceTree,
  },

  computed() {},

  mounted() {
    this.deviceConfig = {
      cameraList: {
        deviceType: "18",
        data: [],
      },
      broadcastList: {
        deviceType: "26",
        data: [],
      },
    };
    this.getDatalist();
    // this.getDevices();
  },
  watch: {
    filterBroadcast(newVal) {
      this.$refs.deviceTree.filter(newVal);
    },
    //  filterBroadcast(val,oldVal) {
    //     this.$refs.deviceTree.filter(val)
    //   }
    filterCamera(newVal) {
      if (newVal) {
        this.deviceListNew = this.deviceListNew.filter((item) => {
          return item.name == newVal;
        });
      } else {
        this.deviceListNew = this.deviceDeviceCopy;
      }
    },
  },
  methods: {
    treeDataHandler(treeData) {
      this.getAreaCodeAndSetKeys(treeData, this.linkageForm.cameraList);
    },
    getAreaCodeAndSetKeys(treeData, cameraList) {
      const treeNodes = [];
      const iterateTree = (treeData, id) => {
        treeData.forEach((node) => {
          if (node.thirdCameraId === id) treeNodes.push(node);
          if (node.children) iterateTree(node.children, id);
        });
      };
      cameraList.forEach((item) => {
        iterateTree(treeData, item.value);
      });
      this.setCheckedKeys(treeNodes);
    },
    setCheckedKeys(cameraList) {
      const treeComRef = this.$refs.cameraTree;
      const treeRef = treeComRef ? treeComRef.$refs.dialogTree : null;
      treeRef && treeRef.setCheckedKeys(cameraList.map((item) => item.id));
    },
    handleSaveChecked(node) {
      this.deviceName = node[0].name;
      // this.$refs.refTable.searchForm["deviceName"] = node[0].name;
    },
    filterBroadcastNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    getAudioList() {
      const params = {
        pageNum: 1,
        pageSize: 100,
      };
      this.$fetch(api.queryAudio, params).then((res) => {
        if (res.success) {
          this.audioData = (res.returnObj && res.returnObj.list) || [];
        } else {
          this.$message.error(res.msgContent || "查询音频列表失败");
        }
      });
    },
    queryDeviceTree() {
      console.log(this.linkageForm.cameraList, this.deviceIdList, "==");
      if (
        !this.deviceConfig["broadcastList"] ||
        !this.deviceConfig["broadcastList"].deviceType
      ) {
        return;
      }
      if (
        this.linkageForm.cameraList.length == 0 ||
        this.linkageForm.cameraList.length > 1
      ) {
        this.getAllVideo();
      } else if (
        this.linkageForm.cameraList &&
        this.linkageForm.cameraList.length == 1
      ) {
        const params = {
          // deviceId: this.linkageForm.cameraList[0].deviceId,
          deviceId: this.linkageForm.cameraList[0].deviceId,
          deviceType: "18",
          distance: "200",
        };
        this.$fetch(api.queryDeviceDistanceList, params).then((res) => {
          if (res.success) {
            // this.deviceConfig[type].data = res.returnObj || [];
            if (!res.returnObj || !res.returnObj.length) {
              this.$message.warning("改摄像机周边范围没有广播");
              this.getAllVideo();
            } else {
              this.deviceConfig["broadcastList"].data = res.returnObj || [];
              this.treeData = this.deviceConfig["broadcastList"].data;
              if (this.treeData && this.treeData.length) {
                this.expandedKeys = [this.treeData[0].id];
              }
            }
          } else {
            this.$message.error(res.msgContent || "查询摄像机列表失败");
          }
        });
      }
    },
    getAllVideo() {
      const params = {
        // 设备子类型 26-广播，18-摄像机
        deviceMarkList: ["26"],
        // 是否需要权限过滤，0：不过滤，1：过滤
        authorityFlag: 1,
      };
      this.$fetch(api.queryAreaDeviceTree, params).then((res) => {
        if (res.success) {
          this.deviceConfig["broadcastList"].data = res.returnObj || [];
          this.treeData = res.returnObj || [];
          if (this.treeData && this.treeData.length) {
            this.expandedKeys = [this.treeData[0].id];
          }
        } else {
          this.$message.error(res.msgContent || "查询摄像机列表失败");
        }
      });
    },
    // 参数查询
    searchChange(searchForm) {
      this.searchForm = searchForm;
      this.getDatalist();
    },
    //重置查询
    searchReset() {
      this.getDatalist();
    },
    sizeChange(size) {
      this.page.pageSize = size;
      this.getDatalist();
    },
    pageChange(page) {
      this.page.pageNum = page;
      this.getDatalist();
    },
    //选择音频
    audioChoose(data) {
      this.choosedList = data;
    },
    deviceChange(data) {},
    //新增||修改保存
    deviceConfirm() {
      // console.log(this.linkageForm, "====linkform");
      this.$refs.linkageForm.validate((res) => {
        if (res) {
          let optStr =
            this.addPanelTitle === "新增联动播放广播信息" ? "新增" : "修改";
          let apiUrl =
            this.addPanelTitle === "新增联动播放广播信息"
              ? api.addLinkage
              : api.updateLinkage;
          let params = {
            // 联动名称
            linkageName: this.linkageForm.linkageName,
            // 联动类型 取枚举
            linkageType: "1",
            // 告警类型
            alarmType: this.linkageForm.alarmType,
            durations: this.linkageForm.durations,
            randomPlay: this.linkageForm.randomPlay,
            linkageFileList: this.linkageForm.audioList.map((item, index) => {
              return {
                name: item.name,
                sortNo: index + 1,
              };
            }),
            // 广播id列表
            thirdBroadcastIdList: this.linkageForm.broadcastList.map((item) => {
              return item.thirdDeviceId || item.thirdCameraId || item.value;
            }),
            // 摄像机id列表
            thirdCameraIdList: this.linkageForm.cameraList.map((item) => {
              // console.log(item, "=====item");
              // return item.value || item.id;
              return item.thirdCameraId;
            }),
            // thirdCameraIdList: this.linkageForm.cameraList,
          };
          if (this.addPanelTitle === "编辑联动播放广播信息") {
            params.linkageCode = this.linkageForm.linkageCode;
          }
          this.$fetch(apiUrl, params).then((res) => {
            if (res.success) {
              this.$message.success(`${optStr}广播联动规则成功`);
              this.getDatalist();
              this.handleClosePanel();
            } else {
              this.$message.error(
                res.msgContent || `${optStr}广播联动规则失败`
              );
            }
          });
        }
      });
    },
    //新增==修改取消
    deviceCancel() {
      this.handleClosePanel();
    },
    deviceClose() {
      this.handleClosePanel();
    },
    //删除设备
    deleteFormItem(type, index) {
      this.linkageForm[type].splice(index, 1);
      console.log(this.linkageForm[type], "===this.linkageForm[type]");
      type == "cameraList" ? this.monitorPointList.splice(index, 1) : "";
      this.$forceUpdate();
    },
    getLinkageDetail(item) {
      // let item = this.dataList[index] || {};
      this.$fetch(api.queryLinkageDetail, {
        linkageCode: item.linkageCode,
      }).then((res) => {
        if (res.success) {
          let result = res.returnObj || {};
          this.alarmChange(parseInt(result.alarmType));
          this.linkageForm = {
            linkageCode: result.linkageCode,
            linkageName: result.linkageName,
            alarmType: parseInt(result.alarmType),
            cameraList: (result.linkageCameraInfoList || []).map((item) => {
              return {
                value: item.thirdCameraId,
                name: item.thirdCameraName,
              };
            }),
            randomPlay: result.randomPlay,
            durations: result.durations,
            broadcastList: (result.linkageBroadcastInfoList || []).map(
              (item) => {
                return {
                  value: item.thirdBroadcastId,
                  name: item.thirdBroadcastName,
                };
              }
            ),
            audioList: (result.linkageFileList || []).map((item) => {
              return {
                sortNo: item.sortNo,
                name: item.name,
                fileCode: item.fileCode,
              };
            }),
          };
          this.deviceChange([]);
          this.showAddPanel = true;
        } else {
          this.$message.error(res.msgContent || "查询广播联动规则详情失败");
        }
      });
    },
    getLeafNodes(nodes) {
      return nodes.filter((node) => node.deviceMark);
    },
    handleDeviceConfirm() {
      let text = "";
      text = this.devicePanelTitle.substr(2, this.devicePanelTitle.length - 1);
      if (this.devicePanelTitle == "添加视频监控点") {
        // this.deviceListNew.map((item) => {
        //   if (this.$refs.checkbox.value.indexOf(item.name) != -1) {
        //     // this.linkageForm.cameraList = [];
        //     this.deviceIdList.push(item);
        //     this.linkageForm.cameraList.push(item);
        //     this.$refs.linkageForm.validateField("cameraList");
        //   }
        // });
        // this.linkageForm.cameraList.length
        //   ? (this.showDevicePanel = false)
        //   : this.$message.warning("请选择" + text);

        const treeComRef = this.$refs.cameraTree;
        const treeRef = treeComRef.$refs.dialogTree;
        if (treeRef) {
          const checkedNodes = treeRef.getCheckedNodes();
          const deviceNodes = this.getLeafNodes(checkedNodes);
          if (!deviceNodes || !deviceNodes.length)
            return this.$message.warning("请选择" + text);

          this.linkageForm.cameraList = deviceNodes;
          this.$refs.linkageForm.validateField("cameraList");
          this.showDevicePanel = false;
        }
      } else if (this.devicePanelTitle == "添加广播设备") {
        let checkDevice = this.$refs.deviceTree.getCurrentNode();
        if (!checkDevice) {
          this.$message.warning("请选择" + text);
          return;
        }
        if (checkDevice.deviceType != 26) {
          this.$message.warning("当前选择的不是广播设备,请重新选择");
          return;
        }
        this.linkageForm.broadcastList = [checkDevice];
        // [
        //   this.$refs.deviceTree.getCurrentNode(),
        // ];
        this.$refs.linkageForm.validateField("broadcastList");
        this.showDevicePanel = false
        // console.log(
        //   this.linkageForm.broadcastList,
        //   this.$refs.deviceTree.getCurrentNode(),
        //   "this.linkageForm.broadcastList.length"
        // );
        // this.$refs.deviceTree.getCurrentNode()
        //   ? (this.showDevicePanel = false)
        //   : this.$message.warning("请选择" + text);
      } else {
        this.linkageForm["audioList"] = this.choosedList.map((item) => {
          return {
            id: item.thirdDeviceId || item.thirdCameraId, //thirdMediaDataId音频id
            name: item.name || "",
            fileCode: item.fileCode,
          };
        });
        this.$refs.linkageForm.validateField("audioList");
        this.linkageForm.audioList.length
          ? (this.showDevicePanel = false)
          : this.$message.warning("请选择" + text);
      }
      // if (
      //   !this.linkageForm.cameraList.length &&
      //   !this.linkageForm.audioList.length &&
      //   !this.linkageForm.broadcastList.length
      // ) {
      //   this.$message.warning("请选择" + text);
      //   return;
      // }
      // this.showDevicePanel = false;
    },
    handleDeviceCancel() {
      this.showDevicePanel = false;
    },
    getDatalist() {
      let params = {
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        alarmType: this.searchForm.alarmType,
        creator: this.searchForm.creator,
        linkageName: this.searchForm.linkageName,
      };
      this.$fetch(api.queryLinkage, params).then((res) => {
        if (res.success) {
          this.tableData = (res.returnObj && res.returnObj.list) || [];
          this.page.total = res.returnObj.total;
        } else {
          this.$message.error(res.msgContent || "查询广播联动规则列表失败");
        }
      });
    },
    // 获取告警设备来源
    async getDevices() {
      await this.queryControlTaskCamera("1");
      await this.queryControlTaskCamera("2");
      await this.queryControlTaskCamera("3");
      await this.queryControlTaskCamera("4");
    },
    queryControlTaskCamera(type) {
      let params = {
        controlFlag: 1,
        controlType: type,
      };
      this.$fetch(api.queryControlTaskCamera, params).then((res) => {
        if (res.success) {
          let arr = [];
          arr = res.returnObj.map((item) => {
            return {
              name: item.deviceName,
              value: item.thirdDeviceId,
              deviceId: item.deviceId,
              areaName: item.areaName,
            };
          });
          this.options[type - 1].children = arr;
        }
      });
    },
    //监控点
    cameraChange(data) {
      console.log(data);
    },
    alarmChange(data) {
      data == 327
        ? (this.typeValue = 1)
        : data == 328
        ? (this.typeValue = 3)
        : data == 335
        ? (this.typeValue = 4)
        : (this.typeValue = 2);
      this.linkageForm.cameraList = [];
      this.deviceListNew = this.options[this.typeValue - 1].children;
      this.deviceDeviceCopy = this.deviceListNew.concat();
    },
    addLinkage() {
      this.addPanelTitle = "新增联动播放广播信息";
      // this.linkageForm = {};

      this.showAddPanel = true;
    },
    handleClosePanel() {
      this.$refs.linkageForm.resetFields();
      this.monitorPointList = [];
      this.showAddPanel = false;
    },
    //修改
    handleEdit(data) {
      this.addPanelTitle = "编辑联动播放广播信息";
      this.getLinkageDetail(data);
      this.showAddPanel = true;
    },
    showDetail(data) {
      this.addPanelTitle = "详情";
      this.getLinkageDetail(data);
    },

    handleDel(data) {
      //   let item = this.dataList[index] || {};
      this.$confirm("确定删除该广播联动规则吗？", "删除广播联动规则", {
        type: "warning",
      })
        .then((result) => {
          if (result) {
            this.$fetch(api.deleteLinkage, {
              linkageCode: data.linkageCode,
            }).then((res) => {
              if (res.success) {
                this.$message.success("广播联动规则删除成功");
                this.getDatalist();
              } else {
                this.$message.error(res.msgContent || "广播联动规则删除失败");
              }
            });
          }
        })
        .catch((e) => {
          this.$log.debug("用户取消删除广播联动规则");
        });
    },
    addDevice(type) {
      if (!this.linkageForm.alarmType) {
        return this.$message.warning("请先选择事件类型");
      }
      if (type == 1) {
        this.devicePanelTitle = "添加视频监控点";
        this.devicePlaceholder = "按名称搜索监控点";
        this.$nextTick(() => {
          const treeComRef = this.$refs.cameraTree;
          // const treeRef = treeComRef ? treeComRef.$refs.dialogTree : null
          treeComRef.openDialog();
        });

        if (this.addPanelTitle === "编辑联动播放广播信息") {
          // todo
        } else {
          this.linkageForm.cameraList = [];
        }
        // this.$refs["deviceTree"].openDialog();
      } else if (type == 2) {
        // if (!this.linkageForm.cameraList) {
        //   this.$message.warning("请先选择视频监控点");
        //   return;
        // }
        console.log(type, "guangbo");
        this.queryDeviceTree();
        this.devicePanelTitle = "添加广播设备";
        this.devicePlaceholder = "按名称搜索公共广播";
      } else {
        this.getAudioList();
        this.devicePanelTitle = "添加联动音频";
      }
      this.showDevicePanel = true;
    },
    //关闭添加设备面板
    handleCloseDevicePanel() {
      this.showDevicePanel = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.device-list {
  height: 100%;
}
.audio-comp-list,
.audio-comp {
  height: 33px;
  // width: 100%;
}
.el-form-item {
  width: 100%;
  display: flex;
  :deep .el-form-item__content {
    width: calc(100% - 120px);
  }
  .el-input__inner {
    width: 100%;
  }
}

.font20 {
  font-size: 20px;
}
.height300 {
  height: 250px;
}
.check-content {
  padding: 10px 0px;
  border-bottom: 1px solid #353945;
  .el-checkbox {
    width: 40%;
  }
  .device-area {
    //padding-left: 50px;
    font-size: 14px;
    width: 50%;
    color: #e1e1e1;
    line-height: 14px;
  }
}
</style>
